import axios from "axios";
import { useAuthStore } from "../store/useAuthStore";

const axiosInstance = axios.create({
  // Always relative: in dev this goes through Vite's own proxy (vite.config.js),
  // which is the single place that needs to know the backend port. Also makes every
  // request same-origin from the browser's point of view, so it isn't gated by the
  // backend's CORS allowlist or broken when Vite falls back to a different port.
  baseURL: "/api",
  withCredentials: true, // send cookies to the server
});

// Add a response interceptor to handle 401 errors silently
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is a 401 Unauthorized error
    if (error.response && error.response.status === 401) {
      // Check if the user is already logged out (to avoid unnecessary warnings)
      const hasLoggedOut = useAuthStore.getState().hasLoggedOut;
      
      // Only log auth errors if not explicitly logged out
      if (!hasLoggedOut) {
        // We could set hasLoggedOut here if needed
        // useAuthStore.setState({ hasLoggedOut: true });
        
        // This is intentionally quiet - we don't want to spam the console
        // with auth errors after logout
      }
      
      // Return rejection but without logging to console
      return Promise.reject({
        ...error,
        response: error.response,
        suppressLog: true // Flag to identify suppressed errors
      });
    }
    
    // For all other errors, proceed with rejection normally
    return Promise.reject(error);
  }
);

export default axiosInstance;